import Loadable from '../../react-loadable';
import { WorkStatusType } from './types';

const WorkStatus = Loadable({ name: 'WorkStatus', loader: () => import(
    /* webpackChunkName: "ui_common_small" */
    './WorkStatus') }) as WorkStatusType;

export type { WorkStatusProps } from './types'

export default WorkStatus;